const { en: common } = require("../../common");

module.exports = {
	...common,
	"legal-terms-of-service-page": require("./legal-terms-of-service-page.json"),
};
